export class CurrentIllness {
  dt?: string;
  onset_date?: string;
  firstname?: string;
  code?: string;
  coding_id?: number;
  patient_id?: number;
  description?: string;
  version_id?: number;
  status?: number;
  lastname?: string;
  [key: string]: any;
}
